module.exports = __webpack_public_path__ + "static/item--window--f3@3x.bb645cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bedroom/item--window--f3@3x.png
// module id = 571
// module chunks = 6850842914447